{
  "dateFormat": "dd/MM/yyyy",
  "accessType": {
    "days_one": "{{count}} día",
    "days_zero": "{{count}} días",
    "days_other": "{{count}} días",
    "byDays": "Por días",
    "until": "Hasta el {{date}}",
    "untilDate": "Hasta una fecha",
    "lifetime": "De por vida"
  },
  "enrollmentStatus": {
    "active": "Activo",
    "expired": "Caducado",
    "cancelled": "Cancelado",
    "pending": "Pendiente",
    "paused": "Pausado"
  },
  "gateways": {
    "guru": {
      "hint": "Pega esta URL en Configuración → Webhooks en el panel de Guru."
    },
    "xtreed": {
      "hint": "En Xtreed, abre el producto → Eventos, crea un evento POST con esta URL, añade la cabecera de arriba y marca order_paid, order_refunded, order_chargeback y subscription_expired. El ID externo es el ID de la oferta (el código que aparece en el enlace del checkout)."
    },
    "hotmart": {
      "hint": "En Hotmart, ve a Herramientas → Webhook, registra esta URL (ya con el token) y marca Compra aprobada, Reembolso, Chargeback y Cancelación de suscripción. El ID externo puede ser el ID del producto o el código de la oferta."
    }
  },
  "copyableField": {
    "copy": "Copiar",
    "copied": "Copiado"
  },
  "list": {
    "title": "Grupos de Acceso",
    "subtitle": "Controla a qué cursos puede acceder cada grupo de alumnos",
    "newGroup": "Nuevo Grupo",
    "searchPlaceholder": "Buscar grupos...",
    "columns": {
      "title": "Título",
      "members": "Miembros",
      "access": "Acceso",
      "products": "Productos",
      "integrations": "Integraciones"
    },
    "inactive": "Inactivo",
    "actions": {
      "edit": "Editar",
      "duplicate": "Duplicar",
      "delete": "Eliminar"
    },
    "deleteConfirm": {
      "title": "Eliminar grupo de acceso",
      "description": "¿Seguro que quieres eliminar este grupo de acceso?",
      "confirm": "Eliminar"
    },
    "toast": {
      "deleted": "Grupo eliminado",
      "deleteError": "Error al eliminar el grupo",
      "duplicated": "Grupo duplicado",
      "duplicateError": "Error al duplicar el grupo"
    },
    "empty": {
      "title": "No se encontraron grupos",
      "searchHint": "Prueba con otra búsqueda",
      "createHint": "Empieza creando tu primer grupo de acceso",
      "create": "Crear Grupo"
    },
    "pagination": {
      "summary_one": "Página {{page}} de {{totalPages}} ({{count}} grupo)",
      "summary_zero": "Página {{page}} de {{totalPages}} ({{count}} grupos)",
      "summary_other": "Página {{page}} de {{totalPages}} ({{count}} grupos)",
      "previous": "Anterior",
      "next": "Siguiente"
    }
  },
  "createDialog": {
    "title": "Crear grupo de acceso",
    "tabs": {
      "info": "Información",
      "products": "Productos",
      "integrations": "Integraciones",
      "members": "Miembros"
    },
    "sections": {
      "general": {
        "title": "Información general",
        "description": "Ingresa los datos generales de tu grupo de acceso. Esta información es esencial para identificarlo dentro del área de administración."
      },
      "accessTime": {
        "title": "Tiempo de acceso",
        "description": "Indica el tiempo disponible que tendrán los miembros para interactuar con los productos registrados en este grupo de acceso."
      },
      "terms": {
        "title": "Términos de uso",
        "description": "Configura el documento de términos de uso que quieres aplicar a este grupo de acceso."
      }
    },
    "accessOptions": {
      "days": {
        "title": "Periodo registrado",
        "description": "El miembro tendrá acceso a los productos según el periodo registrado."
      },
      "lifetime": {
        "title": "De por vida",
        "description": "El miembro tendrá acceso de por vida a los productos."
      },
      "date": {
        "title": "Caducidad fija",
        "description": "El miembro tendrá acceso a los productos hasta la fecha indicada."
      }
    },
    "fields": {
      "title": "Título del grupo *",
      "titlePlaceholder": "Ej.: Pack Completo",
      "description": "Descripción *",
      "descriptionPlaceholder": "Describe qué incluye este grupo...",
      "duration": "Duración (días) *",
      "durationPlaceholder": "Ej.: 365",
      "expirationDate": "Fecha de caducidad *",
      "termsTitle": "Título de los términos de uso",
      "termsTitlePlaceholder": "Ej.: Términos de uso Xtreed",
      "fileUploaded": "Archivo subido",
      "setTerms": "Definir términos de uso"
    },
    "validation": {
      "titleMin": "El título debe tener al menos 3 caracteres",
      "descriptionRequired": "La descripción es obligatoria",
      "descriptionMax": "Máximo 255 caracteres",
      "durationRequired": "Indica la duración en días",
      "expirationRequired": "Indica la fecha de caducidad"
    },
    "locked": {
      "products": "Guarda la información para gestionar los productos del grupo.",
      "integrations": "Guarda la información para configurar las integraciones.",
      "members": "Guarda la información para gestionar los miembros."
    },
    "toast": {
      "fileUploaded": "Archivo subido",
      "fileUploadError": "Error al subir el archivo",
      "created": "Grupo de acceso creado",
      "createError": "Error al crear el grupo"
    },
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "save": "Guardar"
  },
  "formDialog": {
    "titleEdit": "Editar Grupo de Acceso",
    "titleNew": "Nuevo Grupo de Acceso",
    "descriptionEdit": "Edita la información del grupo de acceso",
    "descriptionNew": "Crea un nuevo grupo para organizar productos y inscripciones",
    "fields": {
      "title": "Título *",
      "titlePlaceholder": "Ej.: Pack Completo",
      "description": "Descripción",
      "descriptionPlaceholder": "Describe qué incluye este grupo...",
      "accessType": "Tipo de Acceso",
      "accessTypePlaceholder": "Selecciona el tipo de acceso",
      "lifetime": "De por vida",
      "byDays": "Por días",
      "untilDate": "Hasta una fecha",
      "duration": "Duración (días) *",
      "durationPlaceholder": "Ej.: 365",
      "expirationDate": "Fecha de Caducidad *",
      "status": "Estado",
      "active": "Activo",
      "inactive": "Inactivo",
      "terms": "Términos de uso",
      "termsTitlePlaceholder": "Título de los términos de uso",
      "currentFile": "Archivo actual",
      "setTerms": "Definir términos de uso"
    },
    "validation": {
      "titleMin": "El título debe tener al menos 3 caracteres"
    },
    "toast": {
      "fileUploaded": "Archivo subido",
      "fileUploadError": "Error al subir el archivo"
    },
    "saveError": "Error al guardar el grupo",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "saveChanges": "Guardar Cambios",
    "create": "Crear Grupo"
  },
  "integrationDialog": {
    "titleEdit": "Editar integración",
    "titleNew": "Nueva integración",
    "description": "Conecta una plataforma de pago a este grupo.",
    "fields": {
      "name": "Nombre *",
      "namePlaceholder": "Ej.: Checkout Pack Completo — Guru",
      "gateway": "Plataforma",
      "select": "Selecciona",
      "status": "Estado",
      "active": "Activo",
      "inactive": "Inactivo",
      "externalId": "ID externo (pasarela) *",
      "externalIdPlaceholder": "ID de la oferta/producto en {{gateway}}",
      "externalIdHelp": "Con este ID el webhook identifica el pago e inscribe al alumno en este grupo.",
      "price": "Precio mostrado a los alumnos",
      "priceHelp": "Aparece en el botón de compra del curso bloqueado. Déjalo en blanco para no mostrar precio.",
      "currency": "Moneda"
    },
    "webhookTitle": "Webhook de {{gateway}}",
    "validation": {
      "nameMin": "El nombre debe tener al menos 2 caracteres",
      "externalIdRequired": "El ID externo es obligatorio",
      "price": "Usa un valor como 97 o 97,90"
    },
    "toast": {
      "updated": "Integración actualizada",
      "created": "Integración creada",
      "saveError": "Error al guardar la integración"
    },
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "saveChanges": "Guardar cambios",
    "create": "Crear integración",
    "secret": {
      "urlLabel": "URL del webhook",
      "headerLabel": "Nombre de la cabecera",
      "tokenLabel": "Valor de la cabecera (token)",
      "headerHelp": "Genera el token de esta escuela y envíalo en la cabecera del webhook. Es lo que identifica tu área de miembros.",
      "queryHelp": "Genera el token de esta escuela. Va en la propia URL, porque Hotmart no permite cabeceras personalizadas.",
      "shownOnce": "Cópialo ahora: el token solo se muestra una vez. Generar otro invalida el anterior.",
      "generate": "Generar token",
      "regenerate": "Generar nuevo token",
      "error": "No se pudo generar el token"
    }
  },
  "productsDialog": {
    "status": {
      "published": "Publicado",
      "archived": "Archivado",
      "draft": "Borrador"
    },
    "title": "Productos del grupo",
    "description": "Selecciona los productos incluidos en “{{title}}”.",
    "searchPlaceholder": "Buscar producto...",
    "inGroup": "Productos en el grupo",
    "noResults": "No se encontraron productos",
    "noneSelected": "Aún no hay productos seleccionados",
    "available": "Disponibles",
    "allInGroup": "Todos los productos ya están en el grupo",
    "pageOf": "Página {{page}} de {{total}}",
    "previous": "Anterior",
    "next": "Siguiente",
    "pendingChanges": "{{added}} para añadir · {{removed}} para quitar",
    "selectedCount_one": "{{count}} producto en el grupo",
    "selectedCount_zero": "{{count}} productos en el grupo",
    "selectedCount_other": "{{count}} productos en el grupo",
    "toast": {
      "updated": "Productos actualizados",
      "saveError": "Error al guardar los productos"
    },
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "save": "Guardar"
  },
  "productAssignment": {
    "description": "Añade, quita y reordena los cursos de esta sección",
    "inSection": "En la Sección",
    "courseCount_one": "{{count}} curso",
    "courseCount_zero": "{{count}} cursos",
    "courseCount_other": "{{count}} cursos",
    "emptyTitle": "No hay cursos en esta sección",
    "emptyHint": "Añádelos desde la lista de al lado",
    "available": "Disponibles",
    "searchPlaceholder": "Buscar cursos...",
    "noResults": "No se encontraron cursos",
    "allInSection": "Todos los cursos ya están en esta sección",
    "close": "Cerrar",
    "toast": {
      "added": "Producto añadido a la sección",
      "addError": "Error al añadir el producto",
      "removed": "Producto quitado de la sección",
      "removeError": "Error al quitar el producto",
      "reorderError": "Error al reordenar"
    }
  },
  "detail": {
    "active": "Activo",
    "inactive": "Inactivo",
    "back": "Volver",
    "notFound": "Grupo de acceso no encontrado",
    "backToList": "Grupos de Acceso",
    "membersCount_one": "{{count}} miembro",
    "membersCount_zero": "{{count}} miembros",
    "membersCount_other": "{{count}} miembros",
    "productsCount_one": "{{count}} producto",
    "productsCount_zero": "{{count}} productos",
    "productsCount_other": "{{count}} productos",
    "tabs": {
      "info": "Información",
      "products": "Productos ({{count}})",
      "integrations": "Integraciones",
      "members": "Miembros ({{count}})"
    },
    "deleteIntegrationConfirm": {
      "title": "Eliminar integración",
      "description": "¿Seguro que quieres eliminar esta integración?",
      "confirm": "Eliminar"
    },
    "toast": {
      "integrationDeleted": "Integración eliminada",
      "integrationDeleteError": "Error al eliminar la integración"
    },
    "info": {
      "title": "Información del grupo",
      "edit": "Editar",
      "fields": {
        "title": "Título",
        "status": "Estado",
        "accessType": "Tipo de acceso",
        "products": "Productos",
        "members": "Miembros",
        "createdAt": "Creado el",
        "updatedAt": "Actualizado el",
        "description": "Descripción",
        "terms": "Términos de uso"
      },
      "noDescription": "Sin descripción",
      "termsDefault": "Términos de uso",
      "viewFile": "ver archivo",
      "notDefined": "No definido"
    },
    "products": {
      "title": "Productos en el grupo ({{count}})",
      "description": "Cursos y contenidos disponibles para los miembros de este grupo.",
      "manage": "Gestionar",
      "published": "Publicado",
      "draft": "Borrador",
      "empty": "Aún no hay productos en este grupo",
      "add": "Añadir productos"
    },
    "integrations": {
      "title": "Integraciones configuradas",
      "description": "Checkouts vinculados a este grupo, identificados por el ID externo.",
      "new": "Nueva integración",
      "noExternalId": "Sin ID externo",
      "edit": "Editar",
      "delete": "Eliminar",
      "empty": "Aún no hay integraciones vinculadas a este grupo"
    },
    "members": {
      "title": "Miembros ({{count}})",
      "description": "Alumnos inscritos mediante compra o manualmente.",
      "enroll": "Inscribir",
      "searchPlaceholder": "Buscar por nombre, email o CPF...",
      "statusPlaceholder": "Estado",
      "allStatuses": "Todos los estados",
      "columns": {
        "member": "Miembro",
        "progress": "Progreso",
        "joined": "Alta",
        "expiration": "Caducidad",
        "status": "Estado"
      },
      "pagination": {
        "summary_one": "Página {{page}} de {{totalPages}} ({{count}} miembro)",
        "summary_zero": "Página {{page}} de {{totalPages}} ({{count}} miembros)",
        "summary_other": "Página {{page}} de {{totalPages}} ({{count}} miembros)",
        "previous": "Anterior",
        "next": "Siguiente"
      },
      "emptyFiltered": "No se encontraron miembros con esos filtros",
      "empty": "Aún no hay miembros inscritos",
      "enrollUser": "Inscribir usuario"
    }
  }
}
